import React from "react";
import { appHost } from "../../helpers/uri";

const PrintAdmission = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}/letter/${v?._id}`, "AdmissionLetter", "width=450,height=650");
  };

  // Allow printing when admission is granted (status > 0), no need to wait for acceptance fee
  const hasAdmission = v?.status > 0;

  return (
    <button
      disabled={!hasAdmission}
      onClick={_show}
      className="btn btn-info text-white float-right"
    >
      Print Admission Letter <i className="fa-solid fa-print"></i>
    </button>
  );
};

export default PrintAdmission;
